String.prototype.replaceAll = String.prototype.replaceAll ?? function (s, r): string {
	return this.replace(new RegExp(s, "g"), r);
};

String.prototype.pad = function (l) {
	if (l == null) {
		l = 2;
	}
	let val = this.toString();
	return (val.length < l) ? val.pad(`0${val}`, l) : val;
};

// Extends String with method isNullOrEmpty which accepts a value and return if it is null/undefined or empty
String.isNullOrEmpty = (val: any): boolean => (val === undefined || val === null || val.trim() === "");